// extracted by mini-css-extract-plugin
export default {"container":"Ip-z","brandName":"Jp-z","productName":"Kp-z","productNamePdpEnhancements":"Lp-z","breakLongProductName":"Mp-z"};